import { render, staticRenderFns } from "./TransferForm.vue?vue&type=template&id=028c2bbf"
import script from "./TransferForm.vue?vue&type=script&lang=js"
export * from "./TransferForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports